import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";


function Reviews() {
  const { rpdata } = useContext(GlobalDataContext);


  return (
    <BaseLayout PageName="Reviews">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="Reviews"
          Subheader="Reviews"
          bgimg={`${rpdata?.gallery?.[10]}`}
        />
      </div>
      <div className="w-[90%] md:w-4/5 mx-auto py-[100px]">
        <h2 className="text-center text-white pb-4">
          {rpdata?.labels?.general?.titleReviews}
        </h2>
        <review-widget widgetId="65378b91-f0e8-4964-a626-0e4cc652b4c7"></review-widget>
      </div>
    </BaseLayout>
  );
}

export default Reviews;
